import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-143" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-144" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-145" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-amber-500 bg-yellow-50 text-neutral-900 font-bold text-xs sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-146" data-mp="3d21ty23jwspu">
            HEAVY EQUIPMENT INSTRUCTOR ATLAS
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-neutral-900 uppercase" data-id="element-147" data-mp="3j6fwnlhhz5bq">
            Solve <span className="text-amber-600" data-id="element-148" data-mp="399bcfr77pjxk">Months of Heavy Equipment Training</span> Lesson
            Planning <span className="text-amber-600" data-id="element-149" data-mp="3e84orgarj4w5">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-150" data-mp="30h9djxcskbpe">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-151" data-mp="2vjzq2n8yqa47" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-152" data-mp="2lkiiu1e2bo64">
          <p className="text-sm sm:text-lg md:text-xl text-neutral-800 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-153" data-mp="nb1ld6kmpvxh">
            The Complete{' '}
            <span className="font-semibold text-neutral-900" data-id="element-154" data-mp="ici1dbpliu7r">
              6-IN-1 Visual Heavy Equipment & Machinery Training System
            </span>
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-neutral-800 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-155" data-mp="1azulzgc74ryf">
            <span className="font-semibold text-neutral-900" data-id="element-156" data-mp="162c8dcn8hok3">6 Professional Training Volumes</span> + 5
            Exclusive Instructor Bonuses — Designed to Help You Plan, Teach, Explain & Assess With
            Greater Clarity, Structure and Confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-amber-700 mb-5 sm:mb-7" data-id="element-157" data-mp="3lt74sotvtnt7">
            100% VISUAL MAIN SYSTEM | READY-TO-TEACH RESOURCES | BEGINNER TO ADVANCED
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-158" data-mp="1xa44zhx6qql7">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-159" data-mp="21awbi3eoahds">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-neutral-800/80 mb-3" data-id="element-160" data-mp="2b2ai0v51khgf">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-161" data-mp="2kydscoa1rmeg">
                <CheckCircle size={14} className="text-amber-500" data-id="element-162" data-mp="2l0q76skidgna" />
                <span className="font-medium" data-id="element-163" data-mp="2p10eq9ny8f49">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-neutral-800/60" data-id="element-164" data-mp="2tysfzuahhdl4">
            6 SPECIALIZED ATLASES · 300 VISUAL TRAINING PAGES · 5 PROFESSIONAL BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}